<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <!-- contents -->
      <div class="modal_header">
        <h5>
            {{ title }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="com_head line">
          <h4>Select Environment</h4>
        </div>
        <div class="fx_form_wrap">
          <div class="switch_input_com">
            <input type="radio" id="dev" name="radio" v-model="radioValues" value="dev" @change="radioChange">
            <label for="dev">
                <span>DEV</span>
            </label>
          </div>
          <div class="switch_input_com">
            <input type="radio" id="stg" name="radio" v-model="radioValues" value="stg" @change="radioChange">
            <label for="stg">
                <span>STG</span>
            </label>
          </div>
          <div class="switch_input_com">
            <input type="radio" id="prd" name="radio" v-model="radioValues" value="prd" @change="radioChange">
            <label for="prd">
                <span>PRD</span>
            </label>
          </div>
          <div class="switch_input_com">
            <input type="radio" id="etc" name="radio" v-model="radioValues" value="etc" @change="radioChange">
            <label for="etc">
                <span>ETC</span>
            </label>
          </div>
        </div>
        <div class="comment_wrap line">
          <p>
            {{ comment }}
          </p>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('Dismiss') }}
        </button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="openAWSDefultRole()">
          {{ $t('Login') }}
        </button>
      </div>
      <!-- // contents -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil } from '@/utils';
import RemCommon from '@/mixin/RemCommon';

export default {
  data() {
    return {
      radioValues : 'dev',
      selectedEnv : '',
      title: '',
      comment: '',
    };
  },
  props: {
    csp: '',
    rtnFunc: {
      type: Function,
    },
  },
  computed: {
    _() {
      return _;
    },
  },
  methods: {
    openAWSDefultRole() {
      if(this.selectedEnv === '') {
        this.selectedEnv = this.radioValues;
      }

      this.rtnFunc();

      const realmUrl = {
        aws: 'AWS_KEYCLOCK',
        aws_cn: 'AWS_CN_KEYCLOAK_REALMS',
      }[this.csp] || 'AWS_KEYCLOCK';

      const externalUrl = `${SDLUtil.getExternalUrl('KEYCLOAK_URL')}${SDLUtil.getExternalUrl(realmUrl)}-${this.selectedEnv}`;
      console.log(externalUrl);

      window.open(externalUrl.startsWith('http') ? externalUrl : `http://${externalUrl}`, '_blank');
    },
    radioChange(item) {
      this.selectedEnv = item.target.value;
    }
  },
  created() {
  },
  mounted() {
    if (_.isEqual('aws_cn', this.csp)) {
      this.title = SDLUtil.getMsgProp('cop.home.label.mycsp.awscnDefaultRoleTitle');
      this.comment = SDLUtil.getMsgProp('cop.home.label.mycsp.awscnDefaultRoleComment');
    } else {
      this.title = SDLUtil.getMsgProp('cop.home.label.mycsp.awsDefaultRoleTitle');
      this.comment = SDLUtil.getMsgProp('cop.home.label.mycsp.awsDefaultRoleComment');
    }
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/AwsDefaultRolePopup.vue